import SvgRender from 'common/components/general/SvgRender';
import vessel from 'assets/svg/components/map/vessel.svg';

const Vessel = ({ view }) => {
  return (
    <div>
      <SvgRender
        src={vessel}
        style={{ width: 22, height: 22 }}
        className={view === 'satellite' ? 'text-red' : 'text-primary'}
      />
    </div>
  );
};

export default Vessel;
